//load components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Carousel from './components/Carousel';
import GridItem from './components/GridItem';
import TestimonialCarousel from './components/TestimonialCarousel';

export const components = {
    'body': Navigation,
    'footer': Footer,
    '.slider': Carousel,
    '.grid-item': GridItem,
    '.container__testimonial': TestimonialCarousel
};


// WEBPACK FOOTER //
// ./javascript/components.js